const videos = [
  { folder: 'frames',   totalFrames: 144, label: 'Video 1' },
  { folder: 'frames7',  totalFrames: 121, label: 'Video 2' },
];

export default videos;
